export enum DirectionEnum {
    LEFT,
    RIGHT,
    DOWN,
    UP
}